/* Source: /home/sidsolaiyappan/skooch_ai/shared/drawer_handlers.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { getStoreTasks, getStoreUserId, getStoreIsAnonymous, getStoreDrawerTaskId, getStoreDrawerTitle, getStoreDrawerCategory, getStoreDrawerDeadline, getStoreDrawerPriority, setStoreDrawerTaskId, setStoreDrawerTitle, setStoreDrawerCategory, setStoreDrawerDeadline, setStoreDrawerPriority, setStoreDrawerOverride, setStoreDrawerOpen, setStoreTasks, setStoreSchLog, setStoreSchDirty } from "./store.js";
import { getAccessToken } from "./auth_token.js";
import { updateTaskFullRemote } from "./task_crud_remote.js";
import { schedulerRequestFailed, schedulerErrorText } from "./scheduler_request_helpers.js";
function openDrawer(tid) {
  for (const t of getStoreTasks()) {
    if ((t.id === tid)) {
      setStoreDrawerTaskId(tid);
      setStoreDrawerTitle(t.title);
      setStoreDrawerCategory(t.category);
      setStoreDrawerDeadline(t.deadline);
      setStoreDrawerPriority(t.priority);
      setStoreDrawerOverride("");
      setStoreDrawerOpen(true);
    }
  }
}
function closeDrawer() {
  setStoreDrawerOpen(false);
}
async function saveDrawer() {
  let _uid = getStoreUserId();
  let _editId = getStoreDrawerTaskId();
  if ((!_uid || !_editId)) {
    setStoreDrawerOpen(false);
    return;
  }
  let _newTitle = String(getStoreDrawerTitle()).trim();
  if (!_newTitle) {
    setStoreSchLog("Task name can't be empty.");
    return;
  }
  window.__skoochOpInFlight = true;
  let savedTasks = getStoreTasks();
  let _newCat = getStoreDrawerCategory();
  let _newDeadline = getStoreDrawerDeadline();
  let _newPri = Math.trunc(Number(getStoreDrawerPriority()));
  let _dur = 30;
  for (const t of getStoreTasks()) {
    if ((t.id === _editId)) {
      _dur = (t.duration_mins ? t.duration_mins : 30);
    }
  }
  setStoreTasks(getStoreTasks().map(t => {
    return ((t.id === _editId) ? {"id": t.id, "title": _newTitle, "category": _newCat, "duration_mins": _dur, "priority": _newPri, "deadline": _newDeadline, "status": t.status, "completed": t.completed} : t);
  }));
  window.__skoochSyncSchTasksFromPending();
  let _ok = true;
  let _tok = await getAccessToken();
  let _updRes = await updateTaskFullRemote(_uid, getStoreIsAnonymous(), _tok, _editId, _newTitle, _newCat, _dur, _newPri, _newDeadline);
  if (schedulerRequestFailed(_updRes)) {
    _ok = false;
    setStoreSchLog(schedulerErrorText("Couldn't save task changes", _updRes));
  }
  if (!_ok) {
    setStoreTasks(savedTasks);
    window.__skoochSyncSchTasksFromPending();
    window.__skoochOpInFlight = false;
    return;
  }
  setStoreSchDirty(true);
  setStoreDrawerOpen(false);
  window.__skoochOpInFlight = false;
}
export {closeDrawer, openDrawer, saveDrawer};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:openDrawer": {"is_writer": false, "touches": ["*"]}, "func:closeDrawer": {"is_writer": false, "touches": ["*"]}, "func:saveDrawer": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=drawer_handlers.js.map
